<template>
  <div class="team-member-detail">
    <h3 align="center">Edit Team Member Detail</h3>
    <div style="padding: 10px">
      <form @submit="onSubmit">
        <!-- avatar image -->
        <v-text-field
          label="avatar url"
          v-model="form.avatar_url"
          placeholder="Avatar URL"
        ></v-text-field>
        <b-form-file
          id="input-image"
          v-model="file1"
          placeholder="Choose an image file"
        ></b-form-file>
        <div class="mt-3">
          Selected file: {{ file1 ? file1.name : "" }}<br />
          <b-button @click="uploadImage">Upload</b-button>
        </div>
        <!-- Full Name   -->
        <v-text-field
          label="Full Name"
          v-model="form.full_name"
          placeholder="Enter your Full name"
          autofocus
        ></v-text-field>
        <v-text-field
          v-for="name in getLanguages"
          :key="`Member name${name.id}`"
          :label="`Member Name in ${name.language_name}`"
          v-model="localeName[name.language_code]"
          filled
          placeholder="Enter your Full name"
        ></v-text-field>
        <!-- Contact-->
        <v-text-field
          label="contact"
          v-model="form.contact"
          placeholder="Enter you contact"
        ></v-text-field>
        <!--Email address-->
        <v-text-field
          label="email address"
          v-model="form.email_address"
          placeholder="Enter your email address"
        ></v-text-field>
        <!--Job title-->
        <v-text-field
          label="Job Title"
          v-model="form.job_title"
          placeholder="Enter your Job Title"
        ></v-text-field>
        <!--Flags-->
        <v-checkbox v-model="form.is_team_neko" label="is team neko">
        </v-checkbox>
        <v-checkbox v-model="form.publish" label="publish"> </v-checkbox>
        <v-checkbox
          v-if="canEditRosterStatus"
          v-model="form.is_currently_working"
          :disabled="!rosterStatusApiReady"
          label="Currently working (visible on default team roster)"
        >
        </v-checkbox>
        <p
          v-if="canEditRosterStatus && !rosterStatusApiReady"
          class="caption grey--text"
        >
          Disabled until nekoapi migration 0058 is deployed on the API this CMS
          uses.
        </p>
        <v-text-field
          v-if="canEditRosterStatus && employmentDatesApiReady"
          v-model="form.last_working_date"
          :disabled="form.is_currently_working !== false"
          label="Last working day (YYYY-MM-DD)"
          hint="Last calendar day employed (inclusive). E.g. Owen: 2026-05-31 if active through end of May."
          placeholder="2026-05-31"
          clearable
        />
        <v-text-field
          v-if="canEditRosterStatus && employmentDatesApiReady"
          v-model="form.current_employment_start_date"
          label="Current stint start (YYYY-MM-DD)"
          hint="For rejoins (e.g. Martin): when this employment period began. Leave blank if continuous since date joined."
          placeholder="2024-06-01"
          clearable
        />
        <p
          v-if="canEditRosterStatus && employmentDatesApiReady"
          class="caption grey--text"
        >
          Rejoins use the same NekoHR user — historic timesheets from an earlier
          stint stay under that account. Set stint start so payroll month lists
          only include relevant periods.
        </p>
        <p
          v-else-if="canEditRosterStatus && !employmentDatesApiReady"
          class="caption grey--text"
        >
          Employment end/start dates require nekoapi migration 0061 on this API.
        </p>
        <v-text-field
          v-if="canEditRosterStatus && konekoDepartureApiReady"
          v-model="form.koneko_excluded_from_month"
          label="Hide from Koneko A from month (YYYY-MM)"
          hint="First month they disappear from Koneko planning & budgets (departing). Leave blank while fully on roster."
          placeholder="2026-06"
          clearable
        />
        <p
          v-else-if="canEditRosterStatus && !konekoDepartureApiReady"
          class="caption grey--text"
        >
          Koneko departure month requires nekoapi migration 0059 on this API.
        </p>
        <template v-if="canEditPayrollFields">
          <v-divider class="my-3" />
          <p class="subtitle-2 mb-1">Payroll (出勤簿)</p>
          <v-checkbox
            v-model="form.payroll_monthly_treatment"
            :disabled="!payrollFieldsApiReady"
            label="Monthly employee treatment (月給 — distribute fixed hours across the month)"
          />
          <v-text-field
            v-model.number="form.payroll_monthly_hours"
            :disabled="
              !payrollFieldsApiReady || !form.payroll_monthly_treatment
            "
            label="Monthly target hours"
            hint="Usually 155. Used for payroll export / 出勤簿 when monthly treatment is on."
            type="number"
            min="1"
            step="0.5"
          />
          <p v-if="!payrollFieldsApiReady" class="caption grey--text">
            Requires nekoapi migration 0060 on this API. Until then, Chris /
            Sacha (155h) and Nadir (117h part-time) use built-in defaults in
            Payroll export.
          </p>
        </template>
        <!--address-->
        <v-text-field
          label="address"
          v-model="form.address"
          placeholder="Enter your address"
        ></v-text-field>
        <!--Description-->
        <v-textarea
          auto-grow
          filled
          clearable
          clear-icon="mdi-close-circle"
          label="description"
          v-model="form.description_of_member"
          placeholder="Enter your short description"
        ></v-textarea>
        <v-textarea
          v-for="name in getLanguages"
          :key="`Description Member ${name.id}`"
          :label="`Member Description in ${name.language_name}`"
          v-model="localeDescription[name.language_code]"
          placeholder="Enter your Description"
        ></v-textarea>
        <v-text-field
          label="Job Type"
          v-model="form.job_type"
          placeholder="job type"
        ></v-text-field>
        <label for="birth-datepicker">Date of birth</label>
        <b-form-datepicker
          id="birth-datepicker"
          v-model="form.date_of_birth"
          class="mb-2"
        ></b-form-datepicker>
        <label for="join-datepicker">Joined date</label>
        <b-form-datepicker
          id="join-datepicker"
          v-model="form.date_joined"
          class="mb-2"
        ></b-form-datepicker>

        <v-text-field v-model="form.catch_copy" label="catch_copy">
        </v-text-field>
        <v-row justify="space-around">
          <v-col>
            <v-btn tile type="submit"
              ><v-icon left> mdi-check </v-icon>Submit</v-btn
            >
          </v-col>
          <v-col>
            <v-btn tile @click="closeModal($event.target)"
              ><v-icon left> mdi-close </v-icon>Cancel</v-btn
            >
          </v-col>
          <v-col>
            <v-btn tile @click="remove"
              ><v-icon left> mdi-delete </v-icon>Delete</v-btn
            >
          </v-col>
        </v-row>
      </form>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import axios from "@/services/axios.config";
import {deepCopyJSONObject} from "@/Utilites/helper";
import {userCanManageTeamRosterStatus} from "@/Utilites/teamRosterAdmin";
import {userCanEditPayrollTeamFields} from "@/Utilites/teamPayrollAdmin";
import {
  teamEmploymentDatesSupported,
  teamKonekoDepartureMonthSupported,
  teamPayrollFieldsSupported,
  teamRosterStatusSupported,
} from "@/Utilites/teamRosterApi";
import {PAYROLL_DEFAULT_MONTHLY_HOURS} from "@/config/payrollMonthlyDefaults";

export default {
  props: ["teamDetail", "modalId"],
  name: "EditTeamDetail",
  data() {
    return {
      file1: null,
      memberId: "",
      form: {},
      menu1: false,
      menu2: false,
      switch1: true,
      localeName: {},
      localeDescription: {},
    };
  },
  computed: {
    ...mapGetters([
      "getTeamList",
      "getTeamMemberDetail",
      "getLanguages",
      "userProfileData",
    ]),
    formValueLoaded() {
      return this.getTeamMemberDetail;
    },
    canEditRosterStatus() {
      return userCanManageTeamRosterStatus(this.userProfileData);
    },
    rosterStatusApiReady() {
      return teamRosterStatusSupported(this.getTeamList);
    },
    konekoDepartureApiReady() {
      return teamKonekoDepartureMonthSupported(this.getTeamList);
    },
    canEditPayrollFields() {
      return userCanEditPayrollTeamFields(this.userProfileData);
    },
    payrollFieldsApiReady() {
      return teamPayrollFieldsSupported(this.getTeamList);
    },
    employmentDatesApiReady() {
      return teamEmploymentDatesSupported(this.getTeamList);
    },
  },
  mounted() {
    this.form = deepCopyJSONObject(this.teamDetail);
    if (this.form.is_currently_working === undefined) {
      this.form.is_currently_working = true;
    }
    if (this.form.koneko_excluded_from_month === undefined) {
      this.form.koneko_excluded_from_month = null;
    }
    if (this.form.payroll_monthly_treatment === undefined) {
      this.form.payroll_monthly_treatment = false;
    }
    if (
      this.form.payroll_monthly_hours == null ||
      this.form.payroll_monthly_hours === ""
    ) {
      this.form.payroll_monthly_hours = PAYROLL_DEFAULT_MONTHLY_HOURS;
    }
    if (this.form.last_working_date === "") {
      this.form.last_working_date = null;
    }
    if (this.form.current_employment_start_date === "") {
      this.form.current_employment_start_date = null;
    }
    this.localeName = this.isFormDataNull(this.form.full_name_locale);
    this.localeDescription = this.isFormDataNull(
      this.form.description_of_member_locale
    );
  },
  methods: {
    ...mapActions([
      "fetchTeamDetail",
      "deleteTeamMember",
      "editTeamMember",
      "showLoadingProcess",
      "closeLoading",
    ]),
    isFormDataNull(value) {
      if (value === undefined || value === null) return {};
      return value;
    },
    async uploadImage() {
      try {
        await this.showLoadingProcess();
        let formData = new FormData();
        formData.append("image", this.file1);
        await axios
          .post("api/image/upload/", formData, {
            headers: {
              "Content-type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.form.avatar_url = response.data.data["image"];
          });
      } catch (err) {
        console.log(err);
      } finally {
        await this.closeLoading();
      }
    },

    async remove() {
      const id = this.teamDetail.id;
      const appendToken = this.getToken;
      await this.showLoadingProcess();
      try {
        await this.deleteTeamMember({id, appendToken});
        this.$bvModal.hide(this.modalId);
      } catch (err) {
        console.log(err);
      } finally {
        await this.closeLoading();
      }
    },
    async onSubmit(evt) {
      evt.preventDefault();
      const appendToken = this.getToken;
      const id = this.teamDetail.id;
      this.form.user = this.teamDetail.user;
      this.form.full_name_locale = this.localeName;
      this.form.description_of_member_locale = this.localeDescription;
      const teamForm = {...this.form};
      if (!this.rosterStatusApiReady) {
        delete teamForm.is_currently_working;
      }
      if (!this.konekoDepartureApiReady) {
        delete teamForm.koneko_excluded_from_month;
      } else if (teamForm.koneko_excluded_from_month === "") {
        teamForm.koneko_excluded_from_month = null;
      }
      if (!this.employmentDatesApiReady) {
        delete teamForm.last_working_date;
        delete teamForm.current_employment_start_date;
      } else {
        if (teamForm.last_working_date === "")
          teamForm.last_working_date = null;
        if (teamForm.current_employment_start_date === "") {
          teamForm.current_employment_start_date = null;
        }
        if (teamForm.is_currently_working) {
          teamForm.last_working_date = null;
        }
      }
      await this.showLoadingProcess();
      try {
        await this.editTeamMember({appendToken, id, teamForm});
        this.$bvModal.hide(this.modalId);
      } catch (err) {
        console.log(err);
      } finally {
        await this.closeLoading();
      }
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>
